export const MESSAGE_DELIVERY_QUEUE = 'message-delivery';
export const MESSAGING_REDIS_CHANNEL = 'messaging:events';

export type MessageDeliveryJob = {
  messageId: string;
  conversationId: string;
  senderId: string;
  recipientId: string;
};

export type MessagingRealtimePayload =
  | {
      type: 'message:new';
      conversationId: string;
      message: {
        id: string;
        senderId: string;
        content: string;
        createdAt: string;
      };
    }
  | {
      type: 'conversation:updated';
      conversationId: string;
      preview: string;
      previewSenderId: string;
      updatedAt: string;
    }
  | {
      type: 'unread:changed';
      unreadCount: number;
      messagingUnreadCount: number;
    }
  | {
      type: 'notification:new';
      notificationId: string;
      notificationType: string;
      unreadCount: number;
    };

export type MessagingRedisEnvelope = {
  userId: string;
  event: MessagingRealtimePayload;
};

export function userRoom(userId: string) {
  return `user:${userId}`;
}

export function conversationRoom(conversationId: string) {
  return `conversation:${conversationId}`;
}
